import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import Header from "@/components/Header";
import Footer from "@/components/Footer";

export default function ConsultationCancelPage() {
  return (
    <div className="App bg-white min-h-screen" data-testid="consultation-cancel-page">
      <Header />
      <main className="pt-36 pb-24 min-h-[70vh]">
        <div className="max-w-2xl mx-auto px-6 lg:px-10 text-center">
          <h1 className="font-serif text-4xl text-[var(--gg-deep)] font-semibold">
            No worries — your card was not charged.
          </h1>
          <p className="text-[var(--gg-text)] mt-4 leading-relaxed">
            You cancelled the checkout before completing payment. Your
            selected time slot has been released. When you&apos;re ready, come
            back and choose another time.
          </p>
          <Link
            to="/#contact"
            data-testid="cancel-back-to-form"
            className="inline-flex items-center gap-2 mt-8 bg-[var(--gg-primary)] hover:bg-[var(--gg-primary-dark)] text-white rounded-full px-6 py-3 text-sm"
          >
            <ArrowLeft size={16} /> Back to booking
          </Link>
        </div>
      </main>
      <Footer />
    </div>
  );
}
